// extracted by mini-css-extract-plugin
module.exports = {"alert":"_3UcGvBnku0Nx4MAvSzulQ6","bold":"_2y3ei6T0GDJhuQa2O30MKJ"};